import type { FondDeProjet, PapierDeFiche } from '@nextilt/commun';
import './EchantillonDePapier.css';

/**
 * Un petit bout d'un papier (chantier types-de-fiche, modifications 02 et 06) : l'un des quatre
 * papiers d'une fiche Classique, ou le fond de la carte d'un projet (Post-it compris), dans le
 * menu « Type ▾ » de la fiche, dans le panneau Habit d'un projet et dans Paramètres. Un seul
 * dessin, le même que la fiche, en petit.
 */
export function EchantillonDePapier({
  papier,
  grand = false,
}: {
  papier: PapierDeFiche | Exclude<FondDeProjet, 'uni'>;
  grand?: boolean;
}) {
  return (
    <span
      className={`echantillon-de-papier echantillon-de-papier--${papier}${grand ? ' echantillon-de-papier--grand' : ''}`}
      aria-hidden="true"
    />
  );
}
